module.exports = __webpack_public_path__ + "static/media/7thfloor1.6744c9d6.jpg";